import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRebootMotionLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 35,
	viewBox: "0 0 26 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"data-testid": "reboot-motion-logo",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.29 19.7266C20.0521 18.7156 21.4338 17.4005 22.4378 15.7813C23.4393 14.1621 23.9388 12.4148 23.9388 10.5342C23.9388 7.41314 22.7725 4.87629 20.4425 2.92631C18.11 0.976326 14.525 0 9.68503 0C6.39669 0 3.16919 0.17339 0.00253589 0.520173V7.95465H9.6039V5.34311C9.6039 4.8016 10.4279 4.53218 10.9096 4.91364L16.6167 9.43781C17.1719 9.87796 17.1719 10.7529 16.6167 11.1931L10.9096 15.7172C10.4279 16.0987 9.6039 15.8293 9.6039 15.2878V12.6762H0V31.9973H7.62126V21.5912C9.05626 21.6499 9.99688 21.6792 10.4456 21.6792C11.0136 21.6792 11.4471 21.6659 11.7463 21.6365L17.3494 32H26L18.29 19.7266Z",
		fill: "#FB6A07"
	})]
});
const ForwardRef = forwardRef(SvgRebootMotionLogo);
export { ForwardRef as ReactComponent };
